<template>
  <div>
    <v-container class="grey lighten-5">
      <v-card rounded="xl" elevation="3" class="employee-card p-3">
        <div class="d-flex align-start">
          <v-avatar size="130" border rounded="lg" class="employee-avatar h-100">
            <v-img src="https://cdn-icons-png.flaticon.com/512/149/149071.png" cover/>
          </v-avatar>
          <div class="ml-4">
            <div class="text-h6 font-weight-bold text-primary">
              মোঃ হোসেন আলী ফজল
            </div>
            <div class="d-flex align-center mt-1">
              <v-icon size="16" class="mr-2">mdi-account-tie</v-icon>
              <span class="text-body-2 font-weight-medium">সহকারী প্রোগ্রামার</span>
            </div>
            <div class="d-flex align-center mt-1">
              <v-icon size="16" class="mr-2">mdi-office-building</v-icon>
              <span class="text-body-2">বাংলাদেশ স্থলবন্দর কর্তৃপক্ষ</span>
            </div>
            <div class="d-flex align-center mt-2">
              <v-icon size="16" class="mr-2">mdi-email-outline</v-icon>
              <span class="text-body-2">foyzul86@gmail.com</span>
            </div>
            <div class="d-flex align-center mt-1">
              <v-icon size="16" class="mr-2">mdi-phone-outline</v-icon>
              <span class="text-body-2">+8801912345678</span>
            </div>
          </div>
        </div>
      </v-card>
    </v-container>

    <v-container class="grey lighten-5">
      <v-row>
        <v-col cols="12" md="6" sm="12">
          <v-card rounded="xl" elevation="3" class="employee-card">
            <v-card-title class="font-weight-bold text-info"><v-icon icon="mdi-account-circle-outline" variant="text" />সাধারণ তথ্য</v-card-title>
            <v-divider />
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" sm="12">
                  <v-table density="compact">
                    <tr>
                      <th width="35%">এনআইডি</th>
                      <th width="5%">:</th>
                      <td>৮২১৯৮৬০৪১১</td>
                    </tr>
                    <tr>
                      <th>বয়স</th>
                      <th>:</th>
                      <td>৩৬ বছর ১ মাস ১৮ দিন</td>
                    </tr>
                    <tr>
                      <th>ধর্ম</th>
                      <th>:</th>
                      <td>ইসলাম</td>
                    </tr>
                    <tr>
                      <th>বৈবাহিক অবস্থা</th>
                      <th>:</th>
                      <td>বিবাহিত</td>
                    </tr>
                    <tr>
                      <th>রক্তের গ্রুপ</th>
                      <th>:</th>
                      <td>--</td>
                    </tr>
                    <tr>
                      <th>জন্মস্থান</th>
                      <th>:</th>
                      <td>--</td>
                    </tr>
                  </v-table>
                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <v-table density="compact">
                    <tr>
                      <th width="35%">জন্মতারিখ</th>
                      <th width="5%">:</th>
                      <td>১৩ মার্চ ১৯৯০</td>
                    </tr>
                    <tr>
                      <th>পিআরএল তারিখ</th>
                      <th>:</th>
                      <td>১৩ মার্চ ২০৪৯</td>
                    </tr>
                    <tr>
                      <th>জেন্ডার</th>
                      <th>:</th>
                      <td>পুরুষ</td>
                    </tr>
                    <tr>
                      <th>নিজ জেলা</th>
                      <th>:</th>
                      <td>নওগাঁ</td>
                    </tr>
                    <tr>
                      <th>উচ্চতা</th>
                      <th>:</th>
                      <td>--</td>
                    </tr>
                  </v-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6" sm="12">
          <v-card rounded="xl" elevation="3" class="employee-card">
            <v-card-title class="font-weight-bold text-info"><v-icon icon="mdi-arrow-expand-right" variant="text" /> যোগদানের তথ্য</v-card-title>
            <v-divider />
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" sm="12">
                  <v-table density="compact">
                    <tr>
                      <th width="40%">নিয়োগের ধরন</th>
                      <th width="5%">:</th>
                      <td>সরাসরি</td>
                    </tr>
                    <tr>
                      <th>নিয়োগকারী প্রতিষ্ঠান</th>
                      <th>:</th>
                      <td>বাংলাদেশ স্থল বন্দর কর্তৃপক্ষ</td>
                    </tr>
                    <tr>
                      <th>নিয়ন্ত্রণকারী প্রতিষ্ঠান</th>
                      <th>:</th>
                      <td>বাংলাদেশ স্থল বন্দর কর্তৃপক্ষ</td>
                    </tr>
                    <tr>
                      <th>যোগদানের তারিখ</th>
                      <th>:</th>
                      <td>০৩/০২/২০১৯</td>
                    </tr>
                    <tr>
                      <th>গ্রেড</th>
                      <th>:</th>
                      <td>গ্রেড ৯</td>
                    </tr>
                    <tr>
                      <th>মূল বেতন</th>
                      <th>:</th>
                      <td>-</td>
                    </tr>
                  </v-table>
                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <v-table density="compact">
                    <tr>
                      <th width="40%">চাকরির প্রকার</th>
                      <th width="5%">:</th>
                      <td>নন ক্যাডার</td>
                    </tr>
                    <tr>
                      <th>নিয়োগের আ.তা.</th>
                      <th>:</th>
                      <td>--</td>
                    </tr>
                    <tr>
                      <th>নযোগদান গ্রহণকারী</th>
                      <th>:</th>
                      <td>--</td>
                    </tr>
                    <tr>
                      <th>পদবী</th>
                      <th>:</th>
                      <td>সহকারী প্রোগ্রামার</td>
                    </tr>
                    <tr>
                      <th>বেতনস্কেল</th>
                      <th>:</th>
                      <td>২০১৫, গ্রেড ৯, ২২০০০-৫৩০৬০/-</td>
                    </tr>
                  </v-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="grey lighten-5">
      <v-row>
        <v-col cols="12">
          <v-card rounded="xl" elevation="3" class="employee-card">
            <v-card-title class="font-weight-bold text-info"><v-icon icon="mdi-briefcase" variant="text" /> পদায়নের তথ্য</v-card-title>
            <v-divider />
            <v-card-text>
              <v-table density="compact">
                <thead>
                  <tr>
                    <th class="text-left font-weight-bold">পদবি</th>
                    <th class="text-left font-weight-bold">কর্মস্থল</th>
                    <th class="text-left font-weight-bold">বেতনস্কেল</th>
                    <th class="text-left font-weight-bold">যোগদানের তারিখ</th>
                    <th class="text-left font-weight-bold">অবমুক্তির তারিখ</th>
                    <th class="text-left font-weight-bold">কর্মকাল</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>সহকারী প্রোগ্রামার</td>
                    <td>বাংলাদেশ স্থল বন্দর কর্তৃপক্ষ, ঢাকা</td>
                    <td>২০১৫, গ্রেড ৯, ২২০০০-৫৩০৬০/-</td>
                    <td>০৮/০১/২০২৩</td>
                    <td>--</td>
                    <td>৩ বছর ৩ মাস ২৩ দিন</td>
                  </tr>
                </tbody>
              </v-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="grey lighten-5">
      <v-row>
        <v-col cols="12">
          <v-card rounded="xl" elevation="3" class="employee-card">
            <v-card-title class="font-weight-bold text-info"><v-icon icon="mdi-walk" variant="text" /> পিআরএল তথ্য</v-card-title>
            <v-divider />
            <v-card-text>
              <v-table density="compact">
                <thead>
                  <tr>
                    <th class="text-left font-weight-bold">অবস্থা</th>
                    <th class="text-left font-weight-bold">ভোগ করেছেন</th>
                    <th class="text-left font-weight-bold">অবশিষ্ট</th>
                    <th class="text-left font-weight-bold">শুরুর তারিখ</th>
                    <th class="text-left font-weight-bold">শেষের তারিখ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>শুরু হয়নি</td>
                    <td>০ দিন</td>
                    <td>৩৬৫ দিন</td>
                    <td>১৩/০৩/২০৪৯</td>
                    <td>১২/০৩/২০৫০</td>
                  </tr>
                </tbody>
              </v-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "UserProfile",
};
</script>
